module.exports = __webpack_public_path__ + "static/media/logos_50h_aws.50c2c194.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_aws.jpg
// module id = 211
// module chunks = 0